import { bool, func, number, oneOf, string } from 'prop-types'
import { memo } from 'react'
import RangeSlider from 'react-slider'
import styled from 'styled-components'
const StyledRangeSlider = styled(RangeSlider)`
	border-radius: 3px;
	bottom: -2px;
	height: 4px;
	left: 8px;
	position: absolute !important;
	width: calc(100% - 16px);
`
const StyledThumb = styled.div`
	background-color: var(--main);
	border-radius: 50%;
	cursor: grab;
	height: 20px;
	outline: none;
	top: -9px;
	width: 20px;
	&:active {
		cursor: grabbing;
	}
`
const StyledTrack = styled.div`
	border-radius: 999px;
	bottom: 0;
	top: 0;
	&[data-active='active'] {
		background-color: var(--main);
	}
	&[data-active='inactive'] {
		background-color: transparent;
	}
`
const renderThumb = (props, { index }) => (
	<StyledThumb {...props} key={index} className={null} />
)
const renderTrack = (props, { index, value }) => (
	<StyledTrack
		{...props}
		className={null}
		index={index}
		key={index}
		data-active={index === 0 || index === value.length ? 'active' : 'inactive'}
	/>
)
const StyledSliderInput = styled.div`
	position: relative;
	width: 100%;
	& input {
		background-color: #ffffff;
		border-radius: 10px;
		border-color: #e1e1e1;
		border-radius: 10px;
		border-style: solid;
		border-width: 1.5px;
		color: #292b32;
		font-weight: 500;
		outline: none;
		width: 100%;
		/* 52, 44, 36 */
		font-size: 16px;
		height: 44px;
		padding-left: 15px;
		padding-right: 15px;
		&[data-size='large'] {
			font-size: 18px;
			height: 52px;
			padding-left: 18px;
			padding-right: 18px;
		}
		&[data-size='small'] {
			font-size: 14px;
			height: 36px;
			padding-left: 12px;
			padding-right: 12px;
		}
		&[data-hide-border='true'] {
			border-width: 0;
		}
		&::placeholder {
			color: #717171;
		}
		&[data-error='true']:not(:disabled) {
			border-color: #e41d32;
		}
		&:hover:not(:disabled) {
			border-color: #018ecc;
		}
		&:focus {
			border-color: #018ecc;
		}
		&:disabled {
			background-color: #f4f4f4;
			color: #717171;
			cursor: default;
		}
		.dark & {
			background-color: #2e2d2d;
			color: #e1e1e1;
			border-color: #555555;
			&[data-error='true']:not(:disabled) {
				border-color: #e41d32;
			}
			&:hover:not(:disabled) {
				border-color: #018ecc;
			}
			&:focus {
				border-color: #018ecc;
			}
			&:disabled {
				color: #717171;
			}
		}
	}
`
const SliderInput = memo(
	({
		'data-cy': dataCY,
		hideBorder = false,
		isDisabled = false,
		isError = false,
		max = 100,
		min = 0,
		onChange,
		onFocus,
		placeholder = '',
		ref,
		size = 'medium',
		step = 1,
		value = 0,
	}) => (
		<StyledSliderInput>
			<input
				className='slider-input'
				data-cy={dataCY}
				data-error={isError}
				data-hide-border={hideBorder}
				data-size={size}
				disabled={isDisabled}
				inputMode='numeric'
				onFocus={onFocus}
				placeholder={placeholder}
				ref={ref}
				type='text'
				value={String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
				onChange={e => {
					const value = +e.target.value.replace(/[^0-9]/g, '') || 0
					const newValue = value > max ? max : value < min ? min : value
					onChange(newValue)
				}}
			/>
			<StyledRangeSlider
				defaultValue={[value]}
				disabled={isDisabled}
				max={max}
				min={min}
				minDistance={1}
				onChange={onChange}
				renderThumb={renderThumb}
				renderTrack={renderTrack}
				step={step}
				value={[value]}
			/>
		</StyledSliderInput>
	)
)
SliderInput.propTypes = {
	'data-cy': string,
	hideBorder: bool,
	isDisabled: bool,
	isError: bool,
	max: number,
	min: number,
	onChange: func,
	onFocus: func,
	placeholder: string,
	size: oneOf(['large', 'medium', 'small']),
	step: number,
	value: number,
}
export default SliderInput
